var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("前言(郭醫師的話)")]),_c('MyCkEditor',{attrs:{"height":"600px"},model:{value:(_vm.dataText),callback:function ($$v) {_vm.dataText=$$v},expression:"dataText"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }